import { Divider, Flex, Text, View } from "@adobe/react-spectrum";
import { IndividualTask } from "../../../amazon-connect/models/task";
import Emitter from "../../../emitter";
import { API_MILO_CASE_CHANNEL_TRANSACTION } from "../../../constants/events";
import { useCustomerAttributes } from "../../../hooks/useCustomerAttributes";
import { RootState } from "../../../store/storeConfig";
import { useSelector } from "react-redux";
import { b64DecodeUnicode, formatLabel } from "../../../utils/utils";

interface CaseDetailsProps {
  activeCase: IndividualTask;
}

const CaseDetails: React.FC<CaseDetailsProps> = ({ activeCase }) => {
  const agent = useSelector((state: RootState) => state.agent);
  let caseAttributes = activeCase?.customer?.attributes || {};
  const agentBusinessAttributes = agent?.businessAttributes || [];

  const openMiloPopup = () => {
    Emitter.emit(API_MILO_CASE_CHANNEL_TRANSACTION, {
      type: "notif",
      chan: API_MILO_CASE_CHANNEL_TRANSACTION,
      body: {
        contactId: activeCase?.id,
      },
    });
  };

  const { groupedAttributes } = useCustomerAttributes({
    customerAttrs: caseAttributes,
    businessAttrs: agentBusinessAttributes,
    type: "case-detail",
  });

  return (
    <>
      {(activeCase?.id?.length ?? 0) > 0 && (
        <View UNSAFE_className="caseDetails-wrapper">
          <Flex
            direction={"column"}
            gap={"15px"}
            justifyContent={"space-between"}
          >
            <Flex marginTop={20} direction="row" wrap="wrap" gap={40}>
              <Flex UNSAFE_className="case-detail-item span-2" width={"30%"}>
                <Text UNSAFE_className="case-detail-item-heading">
                  Case Title
                </Text>
                <Text UNSAFE_className="case-detail-item-info">
                  {caseAttributes?.CASE_TITLE || "-"}
                </Text>
              </Flex>
              <Flex UNSAFE_className="case-detail-item" width={"30%"}>
                <Text UNSAFE_className="case-detail-item-heading">
                  Product name
                </Text>
                <Text UNSAFE_className="case-detail-item-info">
                  {caseAttributes?.PRODUCTFAMILY || "-"}
                </Text>
              </Flex>
              <Flex UNSAFE_className="case-detail-item" width={"30%"}>
                <Text UNSAFE_className="case-detail-item-heading">Case ID</Text>
                {caseAttributes?.CASEID ? (
                  <a
                    // href="#"
                    className="case-id-link"
                    onClick={openMiloPopup}
                  >
                    {caseAttributes.CASEID}
                  </a>
                ) : (
                  <Text UNSAFE_className="case-detail-item-info">-</Text>
                )}
              </Flex>
            </Flex>
            {groupedAttributes.length > 0 ? (
              groupedAttributes.map((group, i) => (
                <View key={`group-${i}`} marginTop={20}>
                  <Flex direction="row" wrap="wrap" gap={40}>
                    {group.map((attr, index) => {
                      const label = formatLabel(attr.attributeName);
                      const value = caseAttributes[attr.attributeName] || "-";

                      return (
                        <Flex
                          UNSAFE_className="case-detail-item"
                          width={"30%"}
                          key={`attr-${i + index}`}
                        >
                          <Text UNSAFE_className="case-detail-item-heading">
                            {label}
                          </Text>
                          {label?.toLowerCase() === "t3caseid" &&
                          value !== "-" ? (
                            <a
                              className="case-id-link"
                              onClick={openMiloPopup}
                              style={{
                                cursor: "pointer",
                                color: "#007aff",
                                textDecoration: "underline",
                              }}
                            >
                              {value}
                            </a>
                          ) : (
                            <Text UNSAFE_className="case-detail-item-info">
                              {value}
                            </Text>
                          )}
                        </Flex>
                      );
                    })}
                  </Flex>
                </View>
              ))
            ) : (
              <Flex marginTop={20} justifyContent="center">
                <Text>No Detail Found</Text>
              </Flex>
            )}
          </Flex>
          <Divider size="S" marginY={"20px"} />
          <Flex UNSAFE_className="case-detail-item span-4">
            <Text UNSAFE_className="case-detail-item-heading">
              Case description
            </Text>
            <Text UNSAFE_className="case-detail-item-info">
              {(() => {
                const base64 = caseAttributes?.CASE_DESCRIPTION_BASE64 ?? "";
                if (base64.length === 0) return "NA";
                try {
                  return b64DecodeUnicode(base64);
                } catch (e) {
                  return "NA";
                }
              })()}
            </Text>
          </Flex>
        </View>
      )}
    </>
  );
};

export default CaseDetails;
